import { useMemo } from 'react';
import { parse } from 'libphonenumber-js';
import { regionLanguageMap } from 'services/config/region';
import toLowerCase from 'utils/toLowerCase';
import useCurrentChat from 'hooks/business/im/useCurrentChat';
import { useChatBuyerLang } from 'views/Conversation/Chat/hooks/useChatBuyerLang';

/**
 * 消息编辑器目标语言（翻译/自动翻译用）
 * 单一职责：根据会话渠道、地区、买家信息计算 targetLang
 */
export function useMessageEditorTargetLang(
  conversation: Conversation.Conversation,
): General.Language {
  const { channel, externalBuyerId } = conversation;
  const { preference } = useCurrentChat();
  const buyerLang = useChatBuyerLang(conversation);

  return useMemo(() => {
    if (channel !== 'WA_BIZ') {
      return buyerLang;
    }
    const countryCode: General.UpperCaseRegion = parse(`+${externalBuyerId.replace('+', '')}`)
      .country as any;
    const targetLang: General.Language =
      preference?.buyerLang ?? (regionLanguageMap[toLowerCase(countryCode)] || 'en-US');
    return targetLang;
  }, [externalBuyerId, channel, buyerLang, preference?.buyerLang]);
}
